var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.629 9.948a.247.247 0 00.152.052h6.438a.247.247 0 00.152-.052 5.581 5.581 0 001.884-2.617.25.25 0 00-.237-.331H6.982a.25.25 0 00-.237.331 5.574 5.574 0 001.884 2.617zM6.5 6h11a1.04 1.04 0 001-1 1 1 0 00-1-1 .229.229 0 01-.218-.159 5.552 5.552 0 00-10.564 0A.229.229 0 016.5 4a1 1 0 00-1 1 1.044 1.044 0 001 1z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.916 20a1.088 1.088 0 00.881.977.25.25 0 01.2.245V23a1 1 0 002 0v-1.774a.249.249 0 01.2-.245 1.088 1.088 0 00.887-.981l.738-8.733a.251.251 0 00-.249-.267H9.427a.251.251 0 00-.249.271z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.f917d124.svg";
export { ForwardRef as ReactComponent };